import LiveVideo from './LiveVideo';

export default LiveVideo;
